import { render, staticRenderFns } from "./ExtrTpl.vue?vue&type=template&id=27abd64c&"
import script from "./ExtrTpl.vue?vue&type=script&lang=js&"
export * from "./ExtrTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports